/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react"; // React Stuff
// Common
import StatusBlock from "../common/StatusBlock";
import FadeIn from "../common/FadeIn";
//Packages
import axios from "axios";
import { Container, Row, Button, Col} from "react-bootstrap";
import { isAuthenticated } from "./services/auth"; //import auth
import { Navigate } from "react-router-dom";
// Subcomponents
import ClassTypeEditForm from "./page-parts/ClassTypeEditForm";
import ClassCreationForm from "./page-parts/ClassCreationForm";
//Images and Icons
import { MdOutlineCancel, MdAddCircle, MdModeEdit } from "react-icons/md";

const ClassTypesList = () => {
  const [classTypes, setClassTypes] = useState([]);
  const [classTypeForEdit, setClassTypeForEdit] = useState("");
  // Error and Click Handling
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [submitClicked, setSubmitClicked] = useState(false);
  // View Mode
  const [viewMode, setViewMode] = useState("view");

  // Get the classType Details
  useEffect(async () => {
    const classTypesRequest = await axios.get(`/api/admin/manage/class_types`, {
      withCredentials: true,
    });
    return setClassTypes(classTypesRequest.data);
  }, []);

  // fetch new data when required
  const fetchNewData = async () => {
    const classTypesRequest = await axios.get(`/api/admin/manage/class_types`, {
      withCredentials: true,
    });
    return setClassTypes(classTypesRequest.data);
  };

  // Dismiss Message
  const dismissMessages = () => {
    setSuccessMessage("");
    return setErrorMessage("");
  };

  return (
    <div className='ClassTypesList'>
      <FadeIn delay={250} duration={450}>
        {isAuthenticated() ? (
          <Container>
            <Row className='mt-4 mb-4 text-center'>
              <Col sm='12'>
                <h2>Your Class Types</h2>
                <div>
                  <StatusBlock
                    errorMessage={errorMessage}
                    successMessage={successMessage}
                    dismissMessages={dismissMessages}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col sm='12' className='text-center'>
                <ViewModeButtons setViewMode={setViewMode} viewMode={viewMode} />
              </Col>
            </Row>
            {viewMode === "view" && (
              <ClassTypeBoxes
                classTypes={classTypes}
                fetchNewData={fetchNewData}
                setSubmitClicked={setSubmitClicked}
                submitClicked={submitClicked}
                setErrorMessage={setErrorMessage}
                setClassTypeForEdit={setClassTypeForEdit}
                setViewMode={setViewMode}
                setSuccessMessage={setSuccessMessage}
              />
            )}
            {viewMode === "add" && (
              <ClassCreationForm
                fetchNewData={fetchNewData}
                setSubmitClicked={setSubmitClicked}
                submitClicked={submitClicked}
                setErrorMessage={setErrorMessage}
                setViewMode={setViewMode}
                setSuccessMessage={setSuccessMessage}
              />
            )}
            {viewMode === "edit" && (
              <ClassTypeEditForm
                fetchNewData={fetchNewData}
                setSubmitClicked={setSubmitClicked}
                submitClicked={submitClicked}
                setErrorMessage={setErrorMessage}
                setViewMode={setViewMode}
                setSuccessMessage={setSuccessMessage}
                classTypeForEdit={classTypeForEdit}
                classTypes={classTypes}
              />
            )}
          </Container>
        ) : (
          <Navigate to='/admin/' />
        )}
      </FadeIn>
    </div>
  );
};

const ClassTypeBoxes = (props) => {
  const editClassTypeButton = (_id, e) => {
    e.preventDefault();
    props.setClassTypeForEdit(_id);
    return props.setViewMode("edit");
  };
  const deleteClassType = async (_id, e) => {
    e.preventDefault();
    props.setSubmitClicked(true);
    const deleteTypeRequest = await axios.delete(`/api/admin/manage/class_types/${_id}`, {
      withCredentials: true,
    });
    if (deleteTypeRequest.status === 200) {
      props.setSubmitClicked(false);
      window.scrollTo(10, 0);
      props.setSuccessMessage("Successfully deleted class type.");
      return props.fetchNewData();
    } else {
      props.setSubmitClicked(false);
      window.scrollTo(10, 0);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };
  return (
    <Row>
      {props.classTypes.map((classType) => (
        <Col key={classType._id} sm='12' lg='6'>
          <FadeIn delay={50} duration={450}>
            <div className='mx-1 mt-3 p-2 shadow text-center border'>
              <h3>{classType.Type}</h3>
              <span>
                {classType.LowerAgeString} - {classType.UpperAgeString}
              </span>
              <p>
                <small>{classType.ShortDescription.substring(0, 25)}...</small>
              </p>
              <Button
                variant='primary'
                className='me-1 mb-2'
                onClick={(e) => editClassTypeButton(classType._id, e)}
              >
                View/Edit <MdModeEdit />
              </Button>
              <Button
                variant='danger'
                className='ms-1 mb-2'
                onClick={(e) => deleteClassType(classType._id, e)}
                disabled={props.submitClicked}
              >
                Delete <MdOutlineCancel />
              </Button>
            </div>
          </FadeIn>
        </Col>
      ))}
    </Row>
  );
};


const ViewModeButtons = (props) => {
  if (props.viewMode === "add" || props.viewMode === "edit") {
    return (
      <FadeIn delay={50} duration={450}>
        <Button
          variant='secondary'
          value='view'
          className='m-1'
          onClick={(e) => props.setViewMode(e.target.value)}
        >
          <MdOutlineCancel />
          Return
        </Button>
      </FadeIn>
    );
  } else {
    return (
      <FadeIn delay={50} duration={450}>
        <Button
          variant='primary'
          value='add'
          className='m-1'
          onClick={(e) => props.setViewMode(e.target.value)}
        >
          <MdAddCircle />
          Add a Type
        </Button>
      </FadeIn>
    );
  }
};

export default ClassTypesList;
